// Token logo URLs for Ember and WFLR
export const TOKEN_LOGOS = {
  'FLR': 'https://copper-causal-dove-26.mypinata.cloud/ipfs/bafkreihqxodkuh4ra2qhi4ypja22va7jd6en5gruvpahexmvrq6o5x2r6u',
  'WFLR': 'https://copper-causal-dove-26.mypinata.cloud/ipfs/bafkreibjjbb63qgh4wexnt7t4mytzsf2grzrtytulqqibcwocn6xifvxty',
  'EMBER': 'https://copper-causal-dove-26.mypinata.cloud/ipfs/bafybeicualijz6pzys7g7hwu46jma72gkoshsohjavynf5st5v4p3n4j7e',
};

// Helper function to get token logo URL
export const getTokenLogo = (symbol) => {
  if (!symbol) return null;

  // Handle wrapped tokens (e.g., wXRP -> XRP)
  const cleanSymbol = symbol.toUpperCase().replace(/^W/, '');

  // Return the logo if it exists, otherwise return null
  return TOKEN_LOGOS[symbol.toUpperCase()] || TOKEN_LOGOS[cleanSymbol] || null;
};

// Helper function to get logo for a token pair
export const getTokenPairLogos = (token0, token1) => {
  return {
    token0Logo: getTokenLogo(token0),
    token1Logo: getTokenLogo(token1),
  };
};
